<template>
  <div class="outer-container">
    <div class="container">
      <h2 class="header-font">
        Basic Requirements to enroll this Assessment
      </h2>
      <div class="grid" :style="{ backgroundColor: info.bgColor }">
        <ul v-for="i in info.mainContent" :key="i">
          <li class="manrope custom_white">
            <!-- <h3 class="manrope custom_white"> -->
            {{ i }}
            <!-- </h3> -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      true: Object,
      require: true,
    },
  },
}
</script>

<style scoped>
.outer-container {
  padding: 100px 0;
}
ul {
  list-style-position: outside;
  margin-bottom: 0;
  padding-left: 50px;
}
ul li {
  font-size: 24px;
  font-family: 'Manrope';
}

/* ul li {
  padding-left: 50px;
  list-style: none;
} */
.header-font {
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b !important;
  text-align: center;
  letter-spacing: 0;
  padding-bottom: 40px;
}

.grid {
  max-width: 1300px;
  margin: 0 auto;
  padding: 100px;
  display: grid;
}

.white-bg {
  background-color: #00a653;
  box-shadow: 0px 10px 30px #3c46630d;
  border-radius: 10px;
  min-height: 300px;
}

@media only screen and (max-width: 600px) {
  ul li {
    font-size: 18px;
    font-family: 'Manrope';
  }
  .outer-container {
    padding: 60px 0;
  }
  ul {
    list-style-position: outside;
    margin-bottom: 0;
    padding-left: 15px;
  }
  ul li {
    padding-left: 0px;
  }
  .grid {
    padding: 25px !important;
    background-color: red;
  }
  .grid h3 {
    font-size: 18px;
  }
}
</style>
